"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _444Icon = createIcon({
  displayName: "_444Icon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path
        d="m23.38427 20.337206h87.087601v87.087601h-87.087601z"
        fill="currentColor"
      />
      <path
        d="m145.11337 20.338326h87.08873v87.08873h-87.08873z"
        fill="currentColor"
      />
      <path
        d="m23.38427 144.35201h87.087601v87.086487h-87.087601z"
        fill="currentColor"
      />
      <path
        d="m145.11337 144.35313h87.08873v87.087601h-87.08873z"
        fill="currentColor"
      />
      <path
        d="m267.2374 20.712004h87.087601v87.087601h-87.087601z"
        fill="currentColor"
      />
      <path
        d="m388.96649 20.713123h87.089844v87.08873h-87.089844z"
        strokeMiterlimit="10"
        fill="currentColor"
      />
      <path
        d="m267.2374 144.72682h87.087601v87.086487h-87.087601z"
        fill="currentColor"
      />
      <path
        d="m388.96649 144.72792h87.089844v87.087601h-87.089844z"
        fill="currentColor"
      />
      <path
        d="m23.38427 268.74164h87.087601v87.089844h-87.087601z"
        fill="currentColor"
      />
      <path
        d="m145.11337 268.74164h87.08873v87.089844h-87.08873z"
        fill="currentColor"
      />
      <path
        d="m23.38427 392.75644h87.087601v87.087601h-87.087601z"
        fill="currentColor"
      />
      <path
        d="m145.11337 392.7587h87.08873v87.087601h-87.08873z"
        fill="currentColor"
      />
      <path
        d="m267.2374 268.74164h87.087601v87.087601h-87.087601z"
        fill="currentColor"
      />
      <path
        d="m388.96649 268.74164h87.089844v87.089844h-87.089844z"
        fill="currentColor"
      />
      <path
        d="m267.2374 392.75644h87.087601v87.087601h-87.087601z"
        fill="currentColor"
      />
      <path
        d="m388.96649 392.7587h87.089844v87.087601h-87.089844z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _444Icon;
